import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import Fade from 'react-reveal/Fade'
import { Container, Row, Col } from 'react-grid-system'
import { Helmet } from 'react-helmet'
import {
  OverviewWrap,
  ProjectIntroduction,
  ProjectIntroductionText
} from 'src/components/layout/layout'
import SEO from 'src/components/seo'
import styled from 'styled-components'
import ProjectOverview from 'src/components//projects/project_overview'
import Layout from 'src/components/layout/layout'
import {
  RelatedLinksSection,
  RelatedLinksTitle,
  RelatedLinksList,
  RelatedLinkItem,
  RelatedLink
} from 'src/components/layout/furtherReading'
import CustomRow from 'src/components/core/row'

const StampsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;
  padding: 0 1rem;
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

const StampCard = styled.div`
  min-width: 0;
  aspect-ratio: 1;
  padding: 1rem;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.55);
  border-radius: 6px;
`


const PhotosWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const CaptionedPhoto = styled.figure`
  flex: 1 1 0;
  min-width: 0;
  margin: 0.5rem;
`;

const EqualHeightImage = styled.div`
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px;
  background: white;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
`;

const PhotoCaption = styled.figcaption`
  margin-top: 0.6rem;
  font-size: 0.9rem;
  line-height: 1.4;
  color: #555;
  text-align: center;
`;

const PhotoWrapper = styled.div`
  margin: .5rem;
  border-radius: 8px;
  overflow: hidden;
  flex-grow: 1;
  
  img{
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`

const LinkWrapper = styled.div`
  margin-top: 1rem;
`

const AllPhotos = styled.div`
  
`
const FadeWrapper = styled.div`
  height: calc(100% - 2rem);
  // padding-top: 2rem;
  @media (min-width: 1024) {
    padding-top: 0;
    height: calc(100% - 4rem);
  }
`

const RoyalCoinPage = () => {
  const data = useStaticQuery(graphql`
  query CoinQuery {
    allFile(
      filter: { relativeDirectory: { eq: "coin" } }
      sort: { fields: [base], order: [ASC] }
    ) {
      nodes {
        base
        dir
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`)

  const stamps = data.allFile.nodes.filter((node, idx) => idx <= 3).map(node => node.childImageSharp.fluid)
  const coins = data.allFile.nodes.filter((node, idx) =>
    [4, 5, 8].includes(idx)).map(node => node.childImageSharp.fluid)

  const medals = data.allFile.nodes.filter((node, idx) =>
    [6, 7].includes(idx)).map(node => node.childImageSharp.fluid)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  useEffect(() => {
    console.log(data)
    console.log(stamps)
    console.log(coins)
  }, [data])
  return !loaded ? (
    <Layout />
  ) : (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Martin Jennings - Royal Coins & Stamps</title>
        <meta
          name="description"
          content="I am proud to have designed and modelled the image of HM King Charles III for the new national coinage."
        />
      </Helmet>
      <Fade clear>
        <CustomRow>

          <OverviewWrap>
            <ProjectIntroduction>

              <ProjectIntroductionText>
                <p>
                  Jennings designed and modelled the obverse face of the new national
                  coinage in response to a commission from The Royal Mint. It features
                  King Charles III’s head in profile.
                </p>

                <p>
                  The portrait was first modelled at a larger scale before being digitally
                  scanned and reduced. In collaboration with The Royal Mint team, Jennings
                  then designed the inscriptions that encircle the effigy.
                </p>

                <p>
                  Fifty million coins bearing the design are now in national circulation
                  in various denominations, alongside crowns, sovereigns and other
                  collectable editions.
                </p>

                <p>
                  Working with The Royal Mint’s design team, Jennings also modelled a
                  crowned effigy for a special 2023 Coronation edition.
                </p>
              </ProjectIntroductionText>
            </ProjectIntroduction>

            <Row>
              <PhotoWrapper><Img fluid={coins[0]} /></PhotoWrapper>
              <PhotoWrapper><Img fluid={coins[1]} /></PhotoWrapper>
            </Row>


            <Row>
              <PhotoWrapper><Img fluid={coins[2]} /></PhotoWrapper>
            </Row>

            <ProjectIntroduction>

              <ProjectIntroductionText>
                <p>He was next commissioned to design and model the official British Coronation Medal featuring a double portrait of King Charles and Queen Camilla.</p>
              </ProjectIntroductionText>
            </ProjectIntroduction>
            <Row>
              <CaptionedPhoto>
                <EqualHeightImage>
                  <Img
                    fluid={medals[0]}
                    style={{ width: "100%", height: "100%" }}
                    imgStyle={{ objectFit: "contain" }}
                  />
                </EqualHeightImage>

                <PhotoCaption>
                  Original modelled double portrait.
                </PhotoCaption>
              </CaptionedPhoto>

              <CaptionedPhoto>
                <EqualHeightImage>
                  <Img
                    fluid={medals[1]}
                    style={{ width: "100%", height: "100%" }}
                    imgStyle={{ objectFit: "contain" }}
                  />
                </EqualHeightImage>

                <PhotoCaption>
                  Finished medal adapted and mirror-polished by Worcestershire Medal Service.
                </PhotoCaption>
              </CaptionedPhoto>

            </Row>

            <ProjectIntroduction>

              <ProjectIntroductionText>
                <p>With the approval of the King, a photograph of Jennings’s model for his coin effigy was digitally adapted by The Royal Mint for use by Royal Mail as the definitive image for the nation’s new stamps.</p>
              </ProjectIntroductionText>
            </ProjectIntroduction>
            <Row>
              <StampsGrid>
                {stamps.map((stamp, idx) => (
                  <StampCard key={idx}>
                    <Img
                      fluid={stamp}
                      style={{ width: "100%", height: "100%" }}
                      imgStyle={{ objectFit: "contain" }}
                    />
                  </StampCard>
                ))}
              </StampsGrid>
            </Row>



            <RelatedLinksSection aria-labelledby="related-links-title">
              <RelatedLinksTitle id="related-links-title">
                Further reading
              </RelatedLinksTitle>

              <RelatedLinksList>
                <RelatedLinkItem>
                  <RelatedLink
                    href="https://www.royalmint.com/aboutus/press-centre/the-royal-mint-unveils-official-coin-effigy-of-his-majesty-king-charles-iii/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    The Royal Mint unveils the official coin effigy of His Majesty
                    King Charles III
                  </RelatedLink>
                </RelatedLinkItem>

                <RelatedLinkItem>
                  <RelatedLink
                    href="https://www.bbc.co.uk/news/business-63888781"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    First King Charles 50p coins enter circulation — BBC
                  </RelatedLink>
                </RelatedLinkItem>

                <RelatedLinkItem>
                  <RelatedLink
                    href="https://www.theguardian.com/uk-news/2022/dec/08/first-coinage-featuring-king-charles-iii-released"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    First coinage featuring King Charles III released — The Guardian
                  </RelatedLink>
                </RelatedLinkItem>

                <RelatedLinkItem>
                  <RelatedLink
                    href="https://www.theguardian.com/commentisfree/2023/apr/13/king-charles-head-royal-mint-portrait-ears"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    What modelling King Charles’s head taught me about very public
                    portraits—and sovereignty itself — The Guardian
                  </RelatedLink>
                </RelatedLinkItem>

                <RelatedLinkItem>
                  <RelatedLink
                    href="https://www.royalmint.com/shop/monarch/charles-iii/coronation/the-crowned-coinage-portrait-of-his-majesty-king-charles-iii/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    The Crowned Coinage Portrait of His Majesty King Charles III
                  </RelatedLink>
                </RelatedLinkItem>
                <RelatedLinkItem>
                  <RelatedLink
                    href="https://en.wikipedia.org/wiki/King_Charles_III_Coronation_Medal"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    King Charles III Coronation Medal — Wikipedia
                  </RelatedLink>
                </RelatedLinkItem>

                <RelatedLinkItem>
                  <RelatedLink
                    href="https://www.bbc.co.uk/news/uk-64554857"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    No crown for King Charles on new stamp — BBC
                  </RelatedLink>
                </RelatedLinkItem>
              </RelatedLinksList>
            </RelatedLinksSection>



          </OverviewWrap>
          {/* <AllPhotos>
  <PhotoWrapper><Img fluid={model}/></PhotoWrapper>
</AllPhotos> */}
        </CustomRow>
      </Fade>
      {/* </Container> */}
    </Layout>
  )
}

export default RoyalCoinPage
